import React, { Component } from "react";
import BatchSummary from "../components/analytics/BatchSummary";
import ProductSales from "../components/analytics/ProductSales";

class Analytics extends Component {
    render(){
        return(
            <div>
                <h1>Analytics</h1>
                    <BatchSummary/>
                    <ProductSales/>
            </div>
        )
    }

} export default Analytics